import React, { useState } from 'react';
import NavButton from '../../components/ul/NavButton';
import { useNavigate } from 'react-router-dom';
import { FiMenu, FiX, FiTrash2 } from 'react-icons/fi';

const User_Navbar = ({ selectState }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <nav className="text-main-font w-full p-4">
            <div className="flex justify-between items-center">
                {/* Mobile menu button */}
                <button
                    className="lg:hidden p-2 rounded-lg hover:bg-main-bg transition-colors"
                    onClick={toggleMobileMenu}
                    aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                >
                    {mobileMenuOpen ? (
                        <FiX size={22} className="text-main-font" />
                    ) : (
                        <FiMenu size={22} className="text-main-font" />
                    )}
                </button>

                {/* Desktop navigation */}
                <ul className="hidden lg:flex items-center gap-2">
                    <li>
                        <NavButton to="/manage/user/all/data" btnName="User" selectState={selectState === "user"} />
                    </li>
                    <li>
                        <NavButton to="/manage/user/login/all/data" btnName="Login" selectState={selectState === "login"} />
                    </li>
                    <li>
                        <NavButton to="/manage/user/referral/all/data" btnName="Referral" selectState={selectState === "referral"} />
                    </li>
                </ul>

                {/* Delete Request button - Desktop */}
                <div className="hidden lg:block">
                    <button
                        onClick={() => navigate('/manage/user/all/delete')}
                        className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl font-medium transition-all ${selectState === "delete"
                                ? "bg-main-delete text-main-white"
                                : "bg-main-delete/10 text-main-delete hover:bg-main-delete/20"
                            }`}
                    >
                        <FiTrash2 size={16} />
                        Delete Request
                    </button>
                </div>
            </div>

            {/* Mobile navigation */}
            {mobileMenuOpen && (
                <div className="lg:hidden mt-4 bg-main-white rounded-xl border border-main-border p-4 shadow-sm">
                    <ul className="flex flex-col gap-2">
                        <li>
                            <NavButton to="/manage/user/all/data" btnName="User" selectState={selectState === "user"} />
                        </li>
                        <li>
                            <NavButton to="/manage/user/login/all/data" btnName="Login" selectState={selectState === "login"} />
                        </li>
                        <li>
                            <NavButton to="/manage/user/referral/all/data" btnName="Referral" selectState={selectState === "referral"} />
                        </li>
                        <li className="pt-2 border-t border-main-border mt-2">
                            <button
                                onClick={() => {
                                    navigate('/manage/user/all/delete');
                                    setMobileMenuOpen(false);
                                }}
                                className={`w-full inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl font-medium transition-all ${selectState === "delete"
                                        ? "bg-main-delete text-main-white"
                                        : "bg-main-delete/10 text-main-delete hover:bg-main-delete/20"
                                    }`}
                            >
                                <FiTrash2 size={16} />
                                Delete Request
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </nav>
    );
};

export default User_Navbar;